class @App.Clubs.ClubsApplicationsThankYouView
  constructor: ->
    @bindElements()

  bindElements: ->
    BetterModals.showModal($('#modalExistsNotice')) if $('#modalExistsNotice').length

$(document).on 'turbo:load', ->
  new App.Clubs.ClubsApplicationsThankYouView() if $('.clubsApplicationsThankYouView').length
